import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { TextField } from "@mui/material";
import useModal from "../../hooks/useModal";
import { acceptRejectResignation } from "../../services/exitManagement";
import { toast } from "react-toastify";
import Button from "../ui/Button";

// Define schema
const remarksSchema = z.object({
  remarks: z.string().min(1, "Remarks are required"),
});
const AcceptRejectResignationForm = ({
  resignationId,
  action,
  fetchResignations,
  acceptData,
}) => {
  const { hideModal } = useModal();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(remarksSchema),
    defaultValues: {
      remarks: "",
    },
  });

  const handleResignationApproveRejectSubmit = async (
    data,
    resignationId,
    action
  ) => {
    try {
      const response = await acceptRejectResignation(
        resignationId,
        action,
        data.remarks,
        acceptData
      );
      if (response.status === 200) {
        toast.success(
          response.data.message || "Resignation processed successfully"
        );
        reset();
        hideModal();
        fetchResignations();
      } else {
        toast.error(response.data.message || "Failed to process resignation");
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message || "Bad Request: Invalid data");
      } else {
        console.error("Error submitting resignation:", error);
        toast.error("An unexpected error occurred.");
      }
    }
  };
  return (
    <form
      onSubmit={handleSubmit((data) =>
        handleResignationApproveRejectSubmit(data, resignationId, action)
      )}
      className="pt-2"
    >
      <div className="row mb-3">
        <div className="col-md-12">
          <Controller
            name="remarks"
            control={control}
            render={({ field }) => (
              <TextField
                label="Remarks*"
                variant="standard"
                {...field}
                multiline
                rows={3}
                error={!!errors.remarks}
                helperText={errors.remarks?.message}
                fullWidth
                disabled={isSubmitting}
              />
            )}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end gap-1">
        <Button
          variant="success"
          size="small"
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </Button>
        <Button
          variant="light"
          size="small"
          onClick={hideModal}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
};
export default AcceptRejectResignationForm;
